<template>
  <div class="empty-state">
    <div class="empty-state-msg">
      {{ this.text }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['text'],
}
</script>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  text-align: center;
  padding: 8% 0px;
  width: 100%;

  .empty-state-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 480px;
    min-width: 280px;
    width: auto;
  }

  .empty-state-msg {
    font-weight: 600;
    font-size: 1.5rem;
    margin-top: 1.25rem;
    color: #2d3748;
  }

  .empty-state-action {
    margin-top: 1.5rem;
  }
}
</style>
